import { Document } from "../model/document.types"

export interface DocumentYearGroup {
  year: number
  duerps: Document[]
  papripacts: Document[]
}

//L'année du programme est indépendante de la date de création du document.
//Les anciens documents uploadés restent classés selon leur date.
export function getDocumentYear(document: Document) {
  if (document.type === "papripact" && Number.isInteger(document.content?.programYear)) {
    return document.content.programYear as number
  }
  return new Date(document.date).getFullYear()
}

export function groupDocumentsByYear(documents: Document[], currentYear = new Date().getFullYear()) {
  const sortedDocuments = documents
    .filter((document) =>
      (document.type === "duerp" || document.type === "papripact") &&
      Number.isFinite(new Date(document.date).getTime())
    )
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  const latestDuerp = sortedDocuments.find((document) => document.type === "duerp")
  //Le PAPRIPACT actuel est celui de la dernière année de programme (puis le plus récent), pas le dernier créé.
  const latestPapripact = sortedDocuments
    .filter((document) => document.type === "papripact")
    .sort((a, b) => getDocumentYear(b) - getDocumentYear(a))[0]
  const groups = new Map<number, DocumentYearGroup>([
    [currentYear, { year: currentYear, duerps: [], papripacts: [] }]
  ])

  for (const document of sortedDocuments) {
    const year = getDocumentYear(document)
    if (!groups.has(year)) groups.set(year, { year, duerps: [], papripacts: [] })
    const group = groups.get(year)!
    if (document.type === "duerp") group.duerps.push(document)
    else group.papripacts.push(document)
  }

  //Le DUERP reste dans son historique et apparaît aussi l'année suivante (il vaut 12 mois),
  //ainsi que dans l'année courante tant qu'il est le dernier.
  if (latestDuerp) {
    const latestDuerpYear = getDocumentYear(latestDuerp)
    for (const group of groups.values()) {
      if (group.year === latestDuerpYear + 1 || (group.year === currentYear && group.year > latestDuerpYear)) {
        group.duerps.unshift(latestDuerp)
      }
    }
  }

  return { groups: [...groups.values()].sort((a, b) => b.year - a.year), latestDuerp, latestPapripact }
}
